module.exports = __webpack_public_path__ + "static/img/bg-overview@w.d085998.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/bg-overview@w.jpg
// module id = ltLz
// module chunks = 0